import axios from "../axiosClient";

export const getAllDisplayLocations = async (
  PageNumber: any,
  pageSize: any,
  signal: any,
  SortBy?: any,
  SortDirection?: any,
  searchText?: any
) => {
  const res = await axios.get(`/slpapp/DisplayLocation/GetAll`, {
    params: { PageNumber, pageSize, searchText, SortBy, SortDirection },
    signal,
  });

  return res?.data;
};
